import { apiFetch } from '../lib/api';


// Genera immagini utilizzando l'API serverless
export const generateImage = async (params) => {
  try {
    const {
      prompt,
      model,
      image_size = { width: 1024, height: 1024 },
      num_images = 1,
      enable_safety_checker = true,
      seed,
      negative_prompt,
      image_url,
      mask_url,
      strength,
      openai_api_key,
      loras,
      guidance_scale,
      acceleration,
      enable_prompt_expansion,
      resolution,
    } = params;

    if (!prompt) {
      throw new Error('Prompt is required');
    }

    const requestBody = {
      prompt,
      model,
      image_size,
      num_images,
      enable_safety_checker,
      ...(seed !== undefined && seed !== null && { seed }),
      ...(negative_prompt && { negative_prompt }),
      ...(image_url && { image_url }),
      ...(mask_url && { mask_url }),
      ...(image_url && strength !== undefined && { strength }),
      ...(openai_api_key && { openai_api_key }),
      ...(loras?.length && { loras }),
      ...(guidance_scale !== undefined && { guidance_scale }),
      ...(acceleration && { acceleration }),
      ...(enable_prompt_expansion !== undefined && { enable_prompt_expansion }),
      ...(resolution && { resolution }),
    };


    console.log('Calling serverless API with params:', requestBody);

    const response = await apiFetch('/api/fal/generate-image', {
      method: 'POST',
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      // Prima leggi il testo, poi prova a parsarlo come JSON
      const errorText = await response.text();
      let errorMessage;
      try {
        const errorData = JSON.parse(errorText);
        errorMessage = errorData.error || 'Failed to generate image';
      } catch (parseError) {
        errorMessage = `Server error: ${errorText}`;
      }
      throw new Error(errorMessage);
    }

    // Prima leggi il testo, poi prova a parsarlo come JSON
    const responseText = await response.text();
    let result;
    try {
      result = JSON.parse(responseText);
    } catch (parseError) {
      throw new Error(`Invalid response format: ${responseText.substring(0, 100)}...`);
    }
    
    console.log('Serverless API result:', result);
    return { success: true, data: result.data };

  } catch (error) {
    console.error('Error generating image:', error);
    return {
      success: false,
      error: error.message || 'Internal server error'
    };
  }
};

// Genera video utilizzando l'API serverless
export const generateVideo = async (params) => {
  try {
    const {
      prompt,
      model,
      duration,
      aspect_ratio,
      fps,
      seed,
      image_url,
      strength
    } = params;

    if (!prompt) {
      throw new Error('Prompt is required');
    }

    // RIMUOVI queste righe che causano l'errore:
    // const token = localStorage.getItem('token');
    // if (!token) {
    //   throw new Error('Token mancante');
    // }

    const requestBody = {
      prompt,
      model,
      duration,
      aspect_ratio,
      fps,
      ...(seed !== undefined && seed !== null && { seed }),
      ...(image_url && { image_url }),
      ...(image_url && strength !== undefined && { strength })
    };

    console.log('Calling serverless video API with params:', requestBody);

    const response = await apiFetch('/api/fal/generate-video', {
      method: 'POST',
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to generate video');
    }

    const result = await response.json();
    
    if (!result.success) {
      throw new Error(result.error || 'Video generation failed');
    }

    console.log('Serverless video API result:', result);
    return { success: true, data: result.data };

  } catch (error) {
    console.error('Error generating video:', error);
    return {
      success: false,
      error: error.message || 'Internal server error'
    };
  }
};
